const Colors = {
  accent: "#E32652",
  densedAccent: "#E326524D",
  pink: "#FF6388",
  body: "#FFFFFF",
  // body: "#0E0E0F",
  body1: "#040406",
  white: "#FFFFFF",
  black: "#000000",
  darkGray: "#1D1D1E",
  darkGray1: "#131315",
  headerGray: "#111113",
  lightGray: "#282A2F",
  lightGray1: "#363638",
  textGray: "#979797",
  densedPink: "#DB43438F",
  yellow: "#FFC107",
  green: "#52C93F",
  red: "#FF2727",
  blue: "#3B8AFF",
  error: "#d32f2f",
  primary:"#1b2942"
};

export default Colors;